import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { extractFileName } from "../../common-data/Conversions";
import { uploadImage } from "../../../redux/reducers/postApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";

const BCAUpload = ({
  isEdit,
  rowData,
  closeModal,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.postApi);
  const { postPutLoading } = useSelector((state) => state.common);

  const iniFormValues = {
    bcaFile: "",
    bcaFileUrl: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    if (name === "bcaFile") {
      setFormValues((prev) => ({
        ...prev,
        [name]: type === "file" ? file : value,
      }));

      handleUploadImage(file, name);
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const handleUploadImage = async (file) => {
    try {
      const actionResult = dispatch(
        uploadImage({ file, TOKEN: userInfoData?.token })
      );
      const result = await actionResult;

      if (result?.payload?.status) {
        setFormValues((prev) => ({
          ...prev,
          bcaFileUrl: result?.payload?.image_url || "",
        }));

        toast.success("Document Upload Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleUploadImage ERROR => ", error);
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? "/" : "/ptTrial/bca_report/add";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(iniFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.bcaFile) {
      errors.bcaFile = "BCA Report is required!";
    }

    return errors;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        bca_report: formValues.bcaFileUrl || "",
        trainer_id:
          userInfoData?.user_id ||
          userInfoData?.uid ||
          rowData?.trainer_id ||
          "",
        gym_id:
          userInfoData?.gym_id ||
          userInfoData?.gym_uid ||
          rowData?.gym_id ||
          "",
        uid: rowData?.uid || "",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(handleConfirm, `Are you sure!`, "Cancel", "Upload");
    }
  };

  return (
    <>
      <CommonHeadingNBtns
        title={`Upload BCA Report`}
        onClose={closeModal}
        btnTxt={isEdit ? "Update" : "Submit"}
        onClick={onSubmit}
        isLoading={postPutLoading || loading}
      />

      <div className="form-container bca-report-upload">
        <form className="formContainer">
          <div className="formInputsGrid twoGridSystem">
            <div
              className={`custom-file span2 ${
                formErrors?.bcaFile ? "formError" : ""
              }`}>
              <div className="choosefileBtn">
                <input
                  type="file"
                  className={`custom-file-input ${
                    formValues.bcaFile ? "file-has-value" : ""
                  }`}
                  id="bcaFile"
                  name="bcaFile"
                  aria-describedby="inputGroupFileAddon01"
                  accept="application/pdf"
                  file={formValues.bcaFile}
                  onChange={onChangeInput}
                />
              </div>
              <label className="custom-file-label" htmlFor="bcaFile">
                BCA Report (PDF Only) <span className="required">*</span>
              </label>
              {isEdit && rowData?.bca_report ? (
                <span className="previous-file">
                  Previous:{" "}
                  <a href={rowData.bca_report}>
                    {extractFileName(rowData.bca_report)}
                  </a>
                </span>
              ) : null}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default BCAUpload;
